var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEverythingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515b7e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-active",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca79ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#ffe4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76daff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_Everything_JCR",
    "data-name": "Icon/Everything JCR",
    d: "M9.856,26a1.856,1.856,0,1,1,1.322-3.178A1.856,1.856,0,0,1,9.856,26ZM17,26a1.825,1.825,0,1,1,1.322-.534A1.8,1.8,0,0,1,17,26Zm7.144,0a1.825,1.825,0,1,1,1.322-.534A1.8,1.8,0,0,1,24.144,26ZM9.856,18.856a1.856,1.856,0,1,1,1.322-3.178,1.856,1.856,0,0,1-1.322,3.178Zm7.144,0a1.825,1.825,0,1,1,1.322-.534A1.8,1.8,0,0,1,17,18.856Zm7.144,0a1.825,1.825,0,1,1,1.322-.534A1.8,1.8,0,0,1,24.144,18.856ZM9.856,11.713A1.825,1.825,0,0,1,8,9.856,1.825,1.825,0,0,1,9.856,8a1.825,1.825,0,0,1,1.856,1.856,1.825,1.825,0,0,1-1.856,1.856Zm7.144,0a1.825,1.825,0,0,1-1.856-1.856,1.856,1.856,0,1,1,3.178,1.322A1.8,1.8,0,0,1,17,11.713Zm7.144,0a1.825,1.825,0,0,1-1.856-1.856,1.856,1.856,0,1,1,3.178,1.322A1.8,1.8,0,0,1,24.144,11.713Z",
    transform: "translate(-8 -8)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverythingIcon);
export default __webpack_public_path__ + "static/media/EverythingIcon.bfa3d6b3a6b08a402e43bea832dac26a.svg";
export { ForwardRef as ReactComponent };